import Vue from 'vue'
import router from '../router'
// import api from '@/api/onlineSchool'
import store from '@/store/store'
import { Message } from 'element-ui'

/**
 * 描述：深拷贝
 * @param   : target {object}
 * @return  : {object} 新对象
**/
export function deepClone(target) {
    // 定义一个变量
    let result
    // 如果当前需要深拷贝的是一个对象的话
    if (typeof target === 'object') {
    // 如果是一个数组的话
        if (Array.isArray(target)) {
            result = [] // 将result赋值为一个数组，并且执行遍历
            for (let i in target) {
                // 递归克隆数组中的每一项
                result.push(deepClone(target[i]))
            }
            // 判断如果当前的值是null的话；直接赋值为null
        } else if (target === null) {
            result = null
            // 判断如果当前的值是一个RegExp对象的话，直接赋值
        } else if (target.constructor === RegExp) {
            result = target
        } else {
            // 否则是普通对象，直接for in循环，递归赋值对象的所有值
            result = {}
            for (let i in target) {
                result[i] = deepClone(target[i])
            }
        }
        // 如果不是对象的话，就是基本数据类型，那么直接赋值
    } else {
        result = target
    }
    // 返回最终结果
    return result
}

/**
 * 描述：魔方网校配置资源跳转
 * @param   : type {string} 1：直播课程 2：素材资料 3：自定义链接
 * @param   : isLive {string} 0：非直播课 1：直播课  
 * @param   : url {string} 自定义链接地址
 * @param   : detail_id {string} 直播间id / 课程id
**/
export function gotoPageByConfig({ id, type, isLive, ds_id, live_type, url, detail_id, material_type, course_id }) {
    console.log({ type, isLive, ds_id, live_type, url, detail_id, material_type, course_id });
    if(type == '1') {
        if(isLive == '1') {
            // 直播课
            // window.location.href = `${Vue.prototype.$wx_h5_url}?ds_id=${detail_id}`
            if(localStorage.getItem('token')) {
                if(live_type === '2') {
                    // 跳转班课直播间
                    getCourseLiveToken(ds_id)
                } else if(live_type === '3'){
                    // 跳转伪直播
                    getFakeLiveToken(id, ds_id)
                } else {
                    // 跳转直播
                    getLiveToken(ds_id)
                }
            } else {
                // 记录当前页面地址，方便登登录后重定向
                // const redirectUrl = location.href
                // router.push({ name: 'zhanghaomimadl', query: { redirectUrl: redirectUrl } })
            }
        } else {
            if(live_type === '5') {
                // 跳转商品课程详情
                router.push({ path: `/yuekelist/${course_id}/${detail_id}` })
            } else {
                // 跳转非商品课程详情
                router.push({ path: `/yueke3/${detail_id}` })
            }
        }
    } else if(type == '2') {
        // 素材资料
        // if(material_type === 1) {
        //     // 下载文件
        //     // downloadFile(url)
        //     window.open(url)
        // } else {
        //     // 跳转自定义链接
        //     window.open(url)
        // }
        // 下载文件 或 跳转自定义链接
        window.open(url)
    } else if(type == '3') {
        // 跳转自定义链接
        window.open(url)
    }
}


/**
 * 描述：跳转直播获取token
**/
async function getLiveToken(dsId) {
    const dataParams = {
        org_id: store.getters['user/getOrgId'],
        fans_id: store.getters['user/getFansId']
    }
    const { data: { code, data:responseData } } = await Vue.prototype.$axios.post('/stu/course/getdstoken', dataParams)
    if(code === 200) {
        const { liveToken } = responseData
        // const webInfo = JSON.parse(localStorage.getItem('webInfo'))
        window.open(
            `https://u.shanhuclass.cn/?ds_id=${dsId}&token=${liveToken}&other=1&shool_token=${localStorage.getItem('token')}`
        )
    }
}

/**
 * 描述：描述：跳转伪直播获取token
**/
async function getFakeLiveToken(id, dsId) {
    const dataParams = {
        org_id: store.getters['user/getOrgId'],
        fans_id: store.getters['user/getFansId']
    }
    const { data: { code, data:responseData } } = await Vue.prototype.$axios.post('/stu/course/getdstoken', dataParams)
    if(code === 200) {
        const { liveToken } = responseData
        window.open(
            `https://u.shanhuclass.cn/f/?ds_id=${dsId}&tid=${id}&token=${liveToken}&other=1&shool_token=${localStorage.getItem('token')}`
        )
    }
}


/**
 * 描述：跳转班课直播间获取token
**/
async function getCourseLiveToken(dsId) {
    const dataParams = {
        ds_id: dsId,
        fans_id: store.getters['user/getFansId']
    }
    const { data: { code, data:responseData, message } } = await Vue.prototype.$axios.post('/stu/course/dsAuth', dataParams)
    if(code === 200) {
        const { liveToken } = responseData
        // const webInfo = JSON.parse(localStorage.getItem('webInfo'))
        window.open(
            `https://u.shanhuclass.cn/?ds_id=${dsId}&token=${liveToken}&other=1&shool_token=${localStorage.getItem('token')}`
        )
    } else {
        Message(message || '请求异常')
    }
}


/**
 * 描述：防抖函数
 * @param   : fn {function} , wait {number}
**/
export function debounce(fn, wait) {
    let timer
    return function() {
        const args = arguments
        clearTimeout(timer)
        timer = setTimeout(() =>{
            fn.apply(this, args)
        }, wait)
    }
}

export const secondsToTimeFormat = (seconds) => {
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);
    var secs = seconds % 60;
 
    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    secs = secs < 10 ? '0' + secs : secs;
 
    return hours + ':' + minutes + ':' + secs;
}
